import React, {Component, ReactNode, ChangeEvent} from 'react';
import ChatSmilesScroll from './chat/ChatSmilesScroll';
import ChatSmileItems from './chat/chat_smile_items';
import ChatSmileItemsSlider from './chat/chat_smile_items_slider';
import SearchInput from 'app/components/SearchInput';
import {i18n_t} from 'app/i18n';

interface SmileMenuProps {
    smiles: string[],
    recent_smiles: string[],
    insertSmile: (smile: string) => void
    isLoading: boolean
}

interface SmileMenuState {
    searchValue: string;
}

export default class SmileMenu extends Component<SmileMenuProps, SmileMenuState> {
    constructor(props: SmileMenuProps) {
        super(props);
        this.state = {
            searchValue: ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
    }

    handleChange(event: ChangeEvent<HTMLInputElement>): void {
        this.setState({searchValue: event.target.value});
    }

    clearSearch(): void {
        this.setState({searchValue: ''});
    }

    render(): ReactNode {
        const {smiles, recent_smiles, insertSmile, isLoading} = this.props;
        const {searchValue} = this.state;

        const filteredSmiles = smiles.filter(smile => smile.toLowerCase().includes(searchValue.toLowerCase()));

        return <>
            <ChatSmileItemsSlider
                smiles={recent_smiles}
                insertSmile={insertSmile}
            />
            <SearchInput
                classSearchInput="search-container-smileys"
                classButtonClear="button-clear-smileys"
                handleChange={this.handleChange}
                value={searchValue}
                onClick={this.clearSearch}
            />
            <ChatSmilesScroll>
                <ChatSmileItems
                    smiles={filteredSmiles}
                    insertSmile={insertSmile}
                    titleList={i18n_t('all_emojis_title')}
                    isLoading={isLoading}
                />
            </ChatSmilesScroll>
        </>;
    }
}
